import { trans } from "@mongez/localization";
import { useNavigate } from "@remix-run/react";
import { cn } from "core/shared";
import { useEffect } from "react";
import backgroundShape from "~/assets/images/auth/background-shape.png";
import logoImg from "~/assets/images/logo.png";
import { Close } from "~/design-system/components/icons";
import { BaseLink } from "~/design-system/components/link";
import { URLS } from "~/shared/urls";
import { cartDrawerAtom } from "../../atoms";

type AuthLayoutProps = {
  title?: string;
  imageSrc: string;
  direction: "left" | "right";
  children: React.ReactNode;
  className?: string;
};

export function AuthLayout({
  title,
  imageSrc,
  direction = "left",
  children,
  className,
}: AuthLayoutProps) {
  const navigate = useNavigate();
  const opened = cartDrawerAtom.useOpened();

  useEffect(() => {
    if (opened) {
      cartDrawerAtom.close();
    }
  }, [opened]);

  return (
    <div
      className={cn(
        "flex h-fit min-h-screen items-center justify-center",
        direction === "left"
          ? "flex-col lg:flex-row"
          : "flex-col lg:flex-row-reverse",

        className,
      )}
    >
      <div className="relative hidden h-full min-h-[300px] w-full max-lg:max-h-[300px] lg:block lg:min-h-screen">
        <img
          src={imageSrc}
          alt={title || "authImg"}
          className="absolute inset-0 h-full w-full object-contain object-center"
        />
        <button
          type="button"
          title={trans("back")}
          aria-label={trans("back")}
          onClick={() => navigate(-1)}
          className="hover:bg-primary-900 hover:border-primary-900 absolute top-[5%] flex size-10 cursor-pointer items-center justify-center rounded-full border border-black transition-colors duration-300 hover:text-white lg:top-[12%] lg:hidden ltr:right-[5%] lg:ltr:right-[10%] rtl:left-[5%] lg:rtl:left-[10%]"
        >
          <Close />
        </button>
      </div>
      <div className="bg-primary-light relative flex h-full min-h-screen w-full items-center justify-center overflow-hidden p-5 lg:min-h-screen lg:p-10">
        <img
          src={backgroundShape}
          alt="background"
          className="absolute inset-0 top-0 left-0 h-full w-full object-cover opacity-15"
        />
        <button
          type="button"
          title={trans("back")}
          aria-label={trans("back")}
          onClick={() => navigate(-1)}
          className={cn(
            "hover:bg-primary-900 hover:border-primary-900 absolute top-[5%] hidden size-10 cursor-pointer items-center justify-center rounded-full border border-black transition-colors duration-300 hover:text-white lg:top-[12%] lg:flex",
            direction === "left"
              ? "ltr:right-[5%] lg:ltr:right-[10%] rtl:left-[5%] lg:rtl:left-[10%]"
              : "ltr:left-[5%] lg:ltr:left-[10%] rtl:right-[5%] lg:rtl:right-[10%]",
          )}
        >
          <Close />
        </button>
        <div className="relative z-20 flex h-fit w-full max-w-[550px] flex-col gap-12">
          <BaseLink to={URLS.home} className="flex w-full justify-center">
            <img src={logoImg} alt="logo" />
          </BaseLink>
          <div className="w-full">{children}</div>
        </div>
      </div>
    </div>
  );
}
